// ============================================================
// TaskBridge — Opportunities Data
// Replace/extend with real API calls (e.g. Firestore collection)
// ============================================================

export const CATEGORIES = [
  { id: "all", label: "All Opportunities", icon: "ti-layout-grid", count: 2847 },
  { id: "government", label: "Government", icon: "ti-building-community", count: 412 },
  { id: "ngo", label: "NGOs", icon: "ti-heart-handshake", count: 287 },
  { id: "private", label: "Private Sector", icon: "ti-building", count: 634 },
  { id: "remote", label: "Remote Jobs", icon: "ti-wifi", count: 198 },
  { id: "international", label: "International", icon: "ti-world", count: 156 },
  { id: "internship", label: "Internships", icon: "ti-school", count: 329 },
  { id: "attachment", label: "Attachments", icon: "ti-clipboard-text", count: 214 },
  { id: "graduate", label: "Graduate Trainee", icon: "ti-certificate", count: 89 },
  { id: "scholarship", label: "Scholarships", icon: "ti-award", count: 128 },
];

export const WORK_TYPES = ["Full-Time", "Part-Time", "Contract", "Volunteer", "Internship", "Attachment"];
export const LOCATIONS = ["Nairobi", "Mombasa", "Kisumu", "Nakuru", "Eldoret", "Remote", "Nationwide", "International"];
export const EXPERIENCE_LEVELS = ["Entry Level", "Mid-Level", "Senior", "Student / Trainee", "No Experience Required"];

// Tag color map
export const TAG_COLORS = {
  "Government": "amber",
  "Government Job": "amber",
  "County Government": "amber",
  "NGO": "purple",
  "UN Agency": "purple",
  "International": "blue",
  "Private Sector": "green",
  "Remote": "blue",
  "Internship": "blue",
  "Attachment": "purple",
  "Graduate Trainee": "green",
  "Scholarship": "amber",
  "Full Funding": "green",
  "Healthcare": "green",
  "Technology": "blue",
  "Finance": "blue",
  "Education": "purple",
  "Full-Time": "green",
  "Part-Time": "amber",
  "Contract": "amber",
  "Hybrid": "blue",
};

export const SAMPLE_OPPORTUNITIES = [
  {
    id: "opp-001",
    title: "Medical Laboratory Technologist — Grade 7",
    organization: "Kenya Revenue Authority (KRA)",
    orgShort: "KRA",
    orgColor: { bg: "#fff8e1", text: "#b45309" },
    category: "government",
    tags: ["Government Job", "Healthcare", "Full-Time"],
    location: "Nairobi, Upper Hill",
    salary: "KSh 45,270 – 61,370 p.m.",
    deadline: "2026-06-07",
    postedAt: "2026-06-03T08:00:00",
    type: "Full-Time | Permanent",
    vacancies: 2,
    featured: true,
    verified: true,
    remote: false,
    experienceLevel: "Mid-Level",
    description:
      "The Kenya Revenue Authority invites applications from qualified candidates for the position of Medical Laboratory Technologist. The successful candidates will be responsible for carrying out laboratory investigations and providing accurate results to support clinical decisions at the KRA Medical Centre, Nairobi.",
    requirements: [
      "Diploma in Medical Laboratory Sciences from a recognized institution",
      "Registered with the Kenya Medical Laboratory Technicians and Technologists Board (KMLTTB)",
      "Minimum 2 years post-qualification experience",
      "Proficiency in hematology, microbiology, and biochemistry",
      "Valid practicing license from KMLTTB",
      "Certificate of good conduct (to be presented during interview)",
    ],
    duties: [
      "Perform routine and specialized laboratory tests including blood counts, urinalysis, and cultures",
      "Calibrate, operate, and maintain laboratory equipment",
      "Record, analyze, and report test results accurately and promptly",
      "Maintain quality control standards and SOPs",
      "Ensure safe disposal of laboratory waste",
      "Participate in continuous professional development programs",
    ],
    howToApply: [
      "Download the KRA Application for Employment Form from www.kra.go.ke/careers",
      "Fill the form and attach certified copies of all academic and professional certificates",
      "Email complete application to: recruit@kra.go.ke — Subject: 'Medical Laboratory Technologist – Grade 7'",
      "Alternatively, hand-deliver sealed applications to: Human Resources Division, Times Tower, 22nd Floor, Upper Hill, Nairobi",
      "Applications must be received by Friday, 7th June 2026 at 5:00 PM",
      "Only shortlisted candidates will be contacted for interviews",
    ],
    applyUrl: "https://www.kra.go.ke/careers",
    source: "KRA Official Website",
  },
  {
    id: "opp-002",
    title: "Community Health Officer — 3 Posts",
    organization: "AMREF Health Africa",
    orgShort: "AMREF",
    orgColor: { bg: "#f0fdf4", text: "#166534" },
    category: "ngo",
    tags: ["NGO", "Healthcare", "Entry Level"],
    location: "Kisumu / Mombasa / Nakuru",
    salary: "KSh 35,000 – 50,000 p.m.",
    deadline: "2026-06-25",
    postedAt: "2026-06-03T06:00:00",
    type: "Full-Time | 1-Year Contract (Renewable)",
    vacancies: 3,
    featured: false,
    verified: true,
    remote: false,
    experienceLevel: "Entry Level",
    description:
      "AMREF Health Africa is seeking dynamic Community Health Officers to support our community-based health programs across three counties. The positions will focus on maternal health, nutrition, and preventive healthcare outreach in underserved communities.",
    requirements: [
      "Diploma or Degree in Community Health, Public Health, or Environmental Health",
      "Experience working with Community Health Volunteers (CHVs)",
      "Strong interpersonal, communication, and facilitation skills",
      "Proficiency in data collection tools (ODK/KoboCollect an added advantage)",
      "Ability to ride a motorcycle (Class G license preferred)",
      "Willingness to work in remote rural settings",
    ],
    duties: [
      "Coordinate community health activities and outreach programs",
      "Train, supervise, and support Community Health Volunteers",
      "Collect, enter, and submit monthly program data",
      "Liaise with county health officials and facility in-charges",
      "Conduct household visits and health education sessions",
      "Prepare monthly progress reports for submission to program officer",
    ],
    howToApply: [
      "Prepare a cover letter addressed to: The HR Manager, AMREF Health Africa",
      "Attach your updated CV (maximum 4 pages) with 3 professional referees",
      "Scan and combine documents into one PDF",
      "Email to: recruitment@amref.org — Subject: 'Community Health Officer – [County Name]'",
      "Indicate your preferred county (Kisumu, Mombasa, or Nakuru) in the subject line",
      "Deadline: Wednesday, 25th June 2026. Only shortlisted candidates will be contacted.",
    ],
    applyUrl: "https://amref.org/careers",
    source: "AMREF Official Careers Page",
  },
  {
    id: "opp-003",
    title: "Software Engineering Internship — 2026 Cohort",
    organization: "KCB Bank Group",
    orgShort: "KCB",
    orgColor: { bg: "#eff6ff", text: "#1e40af" },
    category: "internship",
    tags: ["Internship", "Technology", "Hybrid"],
    location: "Nairobi (Hybrid — 3 days office)",
    salary: "KSh 20,000 Stipend p.m.",
    deadline: "2026-07-01",
    postedAt: "2026-06-02T10:00:00",
    type: "Internship | 6 Months",
    vacancies: 15,
    featured: false,
    verified: true,
    remote: false,
    experienceLevel: "Student / Trainee",
    description:
      "KCB Bank Group is offering a 6-month Software Engineering Internship for final-year students and recent graduates. You will work alongside experienced engineers on real banking technology products, gaining hands-on experience in mobile banking, API development, cloud infrastructure, and data systems.",
    requirements: [
      "Final-year student or recent graduate (2024–2026) in Computer Science, IT, Software Engineering, or related field",
      "Proficiency in at least one: Java, Python, JavaScript, or Kotlin",
      "Understanding of REST APIs, databases (SQL/NoSQL), and version control (Git)",
      "Strong problem-solving skills and attention to detail",
      "Available full-time for a 6-month commitment starting August 2026",
      "Minimum B plain (or equivalent) in relevant undergraduate course",
    ],
    duties: [
      "Develop and test features for KCB mobile banking and web applications",
      "Participate in agile sprint planning, standups, and retrospectives",
      "Write clean, well-documented, and testable code",
      "Collaborate with cross-functional teams (product, design, QA)",
      "Shadow senior engineers and attend internal tech talks",
      "Present a project deliverable at the end of the internship",
    ],
    howToApply: [
      "Visit the KCB Careers Portal: careers.kcbgroup.com",
      "Search for 'Software Engineering Intern 2026' and click Apply",
      "Create an account or log in to your existing KCB Careers profile",
      "Upload your CV, academic transcripts, and a 300-word personal statement explaining your interest",
      "Complete the online skills assessment (approximately 45 minutes)",
      "Applications reviewed on a rolling basis — early applications strongly encouraged",
    ],
    applyUrl: "https://careers.kcbgroup.com",
    source: "KCB Careers Portal",
  },
  {
    id: "opp-004",
    title: "Student Nurse Attachment — 47 Positions",
    organization: "Ministry of Health Kenya",
    orgShort: "MOH",
    orgColor: { bg: "#faf5ff", text: "#6b21a8" },
    category: "attachment",
    tags: ["Government", "Attachment", "Healthcare"],
    location: "47 Counties Nationwide",
    salary: "Allowance: KSh 5,000 p.m.",
    deadline: "2026-06-09",
    postedAt: "2026-05-31T09:00:00",
    type: "Attachment | 3 Months",
    vacancies: 47,
    featured: false,
    verified: true,
    remote: false,
    experienceLevel: "Student / Trainee",
    description:
      "The Ministry of Health Kenya, in partnership with county governments, is offering clinical attachment positions for student nurses at county referral hospitals across all 47 counties. This is a mandatory industrial attachment for nursing students in their 3rd or 4th year of study.",
    requirements: [
      "Enrolled student in a Kenya Nursing Council (KNC) accredited nursing program",
      "Must be in 3rd or 4th year of the nursing degree/diploma program",
      "Attachment letter from your institution",
      "National ID / Student ID",
      "Medical fitness certificate from a recognized health facility",
      "Two passport-size photographs",
    ],
    duties: [
      "Rotate through all major clinical departments (medical, surgical, pediatric, maternity)",
      "Assist in patient assessment, monitoring, and care under supervision",
      "Participate in ward rounds and clinical case discussions",
      "Document patient care accurately in health records",
      "Adhere to infection prevention and control protocols",
      "Maintain professional conduct at all times",
    ],
    howToApply: [
      "Obtain an attachment request letter from your institution's Dean/HOD",
      "Write a personal application letter addressed to: County Director of Health, [Your County]",
      "Attach: certified academic transcripts, ID copy, institution letter, and 2 passport photos",
      "Submit physically to the Human Resources Office at your preferred County Referral Hospital",
      "Alternatively, email to the County Health Department (see MOH website for county emails)",
      "Apply early — positions are allocated on a first-come, first-served basis per county",
    ],
    applyUrl: "https://www.health.go.ke",
    source: "Ministry of Health Kenya",
  },
  {
    id: "opp-005",
    title: "MasterCard Foundation Scholars Program 2026",
    organization: "MasterCard Foundation / African Universities",
    orgShort: "MCF",
    orgColor: { bg: "#fef3c7", text: "#92400e" },
    category: "scholarship",
    tags: ["Scholarship", "International", "Full Funding"],
    location: "Canada / Africa (Multiple Universities)",
    salary: "Full Scholarship — Tuition + Living + Travel",
    deadline: "2026-08-31",
    postedAt: "2026-05-29T12:00:00",
    type: "Scholarship | Masters / PhD (2–4 Years)",
    vacancies: 500,
    featured: true,
    verified: true,
    remote: false,
    experienceLevel: "Entry Level",
    description:
      "The MasterCard Foundation Scholars Program provides transformative educational opportunities for young Africans with the potential to lead. The program covers full tuition, accommodation, living allowance, travel, and health insurance at top universities in Canada and Africa.",
    requirements: [
      "African citizen currently residing in Africa",
      "Undergraduate degree with strong academic performance (minimum Second Class Upper or equivalent)",
      "Maximum age of 35 years at time of application",
      "Demonstrated financial need",
      "Evidence of leadership potential and commitment to give back to community",
      "Acceptance letter from a MasterCard Foundation partner university",
    ],
    duties: [
      "Maintain satisfactory academic progress throughout the program",
      "Participate in MasterCard Foundation Scholars Program activities and forums",
      "Engage in community service and mentorship of junior scholars",
      "Submit mandatory reports to MasterCard Foundation at each semester",
      "Return to Africa after completion and contribute to the continent's development",
    ],
    howToApply: [
      "Identify a partner university (e.g., University of Toronto, McGill, University of Nairobi, Ashesi University)",
      "Apply for and obtain admission to a graduate program at a partner institution",
      "Complete the MasterCard Foundation Scholars Program online application form at mastercardfdn.org",
      "Prepare: 2 academic reference letters, personal essay (500 words), academic transcripts (certified), financial need statement",
      "Submit all documents by the university-specific deadline (varies — check partner university portal)",
      "Shortlisted candidates will be interviewed by the MasterCard Foundation selection committee",
    ],
    applyUrl: "https://mastercardfdn.org/all-programs/scholars/becoming-a-scholar/",
    source: "MasterCard Foundation Official",
  },
  {
    id: "opp-006",
    title: "ICT Graduate Trainee Program — 2026",
    organization: "Kenya Revenue Authority (KRA)",
    orgShort: "KRA",
    orgColor: { bg: "#fff8e1", text: "#b45309" },
    category: "graduate",
    tags: ["Government", "Graduate Trainee", "Technology"],
    location: "Nairobi / Nationwide",
    salary: "KSh 30,000 – 40,000 p.m.",
    deadline: "2026-06-30",
    postedAt: "2026-06-01T07:00:00",
    type: "Graduate Trainee | 1 Year",
    vacancies: 20,
    featured: false,
    verified: true,
    remote: false,
    experienceLevel: "Entry Level",
    description:
      "KRA is recruiting ICT Graduate Trainees for a structured 1-year development program. Successful candidates will rotate across ICT departments including Systems Development, Network Infrastructure, Cybersecurity, and Data Analytics, gaining comprehensive exposure to enterprise ICT in a revenue authority.",
    requirements: [
      "Bachelor's degree in Computer Science, Information Technology, Software Engineering, or related field",
      "Graduated between 2023 and 2025 (Upper Second Class Honours or equivalent)",
      "No prior full-time work experience in ICT required",
      "Kenyan citizen aged 28 years or below",
      "Strong analytical, communication, and teamwork skills",
      "KCSE mean grade of B+ and above",
    ],
    duties: [
      "Rotate across ICT departments on a quarterly basis",
      "Assist in systems analysis, development, testing, and deployment",
      "Support network administration and helpdesk operations",
      "Participate in cybersecurity awareness and incident response activities",
      "Contribute to data analytics and reporting projects",
      "Attend structured training sessions and mentorship programs",
    ],
    howToApply: [
      "Go to KRA's e-Recruitment portal: careers.kra.go.ke",
      "Register and create a profile if you don't have one",
      "Search for 'ICT Graduate Trainee 2026' and click Apply Now",
      "Upload: CV, degree certificate/transcripts, national ID, KCSE certificate",
      "Complete the online screening questionnaire",
      "Deadline: 30th June 2026. KRA is an equal opportunity employer.",
    ],
    applyUrl: "https://careers.kra.go.ke",
    source: "KRA e-Recruitment Portal",
  },
  {
    id: "opp-007",
    title: "Web Developer — Remote (Africa-Based)",
    organization: "Andela",
    orgShort: "AND",
    orgColor: { bg: "#f0fdf4", text: "#166534" },
    category: "remote",
    tags: ["Private Sector", "Remote", "Technology"],
    location: "Fully Remote (Kenya / Africa)",
    salary: "USD 2,000 – 4,500 p.m.",
    deadline: "2026-07-15",
    postedAt: "2026-06-01T14:00:00",
    type: "Full-Time | Permanent",
    vacancies: 8,
    featured: false,
    verified: true,
    remote: true,
    experienceLevel: "Mid-Level",
    description:
      "Andela is hiring mid-level Web Developers to join its distributed engineering talent network. You will be matched with high-growth technology companies globally, working remotely from Kenya on exciting product development projects.",
    requirements: [
      "3+ years of professional web development experience",
      "Strong proficiency in React.js, Node.js, or Vue.js",
      "Experience with RESTful APIs and relational databases",
      "Familiarity with cloud platforms (AWS, GCP, or Azure)",
      "Excellent English communication skills (written and verbal)",
      "Reliable internet connection (minimum 10 Mbps) and dedicated workspace",
    ],
    duties: [
      "Build and maintain web applications for Andela client companies",
      "Participate in code reviews and contribute to engineering best practices",
      "Collaborate async with distributed international teams",
      "Meet sprint deliverables and communicate blockers proactively",
      "Continuously upskill via Andela's learning platform",
    ],
    howToApply: [
      "Create or update your Andela profile at andela.com/for-engineers",
      "Complete the technical skills assessment (approximately 90 minutes)",
      "Pass the video interview and code review session",
      "If approved, you are added to the Andela talent network and matched with clients",
      "The process typically takes 2–4 weeks from application to placement",
    ],
    applyUrl: "https://andela.com/for-engineers",
    source: "Andela Careers",
  },
  {
    id: "opp-008",
    title: "UNDP Kenya Internship — Climate & Environment",
    organization: "United Nations Development Programme",
    orgShort: "UNDP",
    orgColor: { bg: "#eff6ff", text: "#1e40af" },
    category: "internship",
    tags: ["UN Agency", "Internship", "Remote"],
    location: "Nairobi / Hybrid",
    salary: "USD 600 p.m. Living Allowance",
    deadline: "2026-07-20",
    postedAt: "2026-05-28T11:00:00",
    type: "Internship | 6 Months",
    vacancies: 4,
    featured: false,
    verified: true,
    remote: false,
    experienceLevel: "Student / Trainee",
    description:
      "UNDP Kenya is seeking motivated interns to support its Climate Change and Environment portfolio. Interns will work with senior programme officers on climate adaptation projects, data analysis, stakeholder engagement, and knowledge management activities.",
    requirements: [
      "Enrolled in or recently graduated (within 1 year) from a master's or final-year undergraduate program",
      "Field of study: Environmental Science, Climate Studies, Development Economics, or related",
      "Strong research, analytical, and writing skills",
      "Experience with Microsoft Office and data visualization tools",
      "Kenyan national or holder of a valid Kenyan work/study permit",
      "Fluency in English; Swahili is an advantage",
    ],
    duties: [
      "Assist in preparing programme reports, briefs, and knowledge products",
      "Conduct literature reviews and policy analyses",
      "Support organization of stakeholder meetings and workshops",
      "Contribute to UNDP Kenya's social media and communications outputs",
      "Maintain programme data tracking systems and databases",
    ],
    howToApply: [
      "Visit the UNDP Jobs Portal: jobs.undp.org",
      "Search for 'UNDP Kenya Climate Intern 2026' vacancy",
      "Complete the online application form and upload your CV (UNDP P11 format preferred)",
      "Attach: cover letter (max 500 words), proof of enrollment/recent graduation, ID",
      "Applications without complete documentation will not be considered",
      "Only shortlisted candidates will receive further communications",
    ],
    applyUrl: "https://jobs.undp.org",
    source: "UNDP Jobs Portal",
  },
];

// Utility: days until deadline
export function daysUntilDeadline(deadlineStr) {
  const now = new Date();
  const deadline = new Date(deadlineStr);
  const diff = Math.ceil((deadline - now) / (1000 * 60 * 60 * 24));
  return diff;
}

// Utility: human-readable time since posting
export function timeAgo(dateStr) {
  const now = new Date();
  const posted = new Date(dateStr);
  const diff = Math.floor((now - posted) / 1000);
  if (diff < 3600) return `${Math.floor(diff / 60)} minutes ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} hours ago`;
  if (diff < 604800) return `${Math.floor(diff / 86400)} days ago`;
  return posted.toLocaleDateString("en-KE", { day: "numeric", month: "short" });
}
